import type { ChangeEvent, ReactNode } from 'react';

import { TabsItemInput, TabsItemLabel, TabsItemLi } from './TabsItem.styled';

type Props = {
  isSelected: boolean;
  children: ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  variant: 'background' | 'marker' | 'compact-marker';
  tabButtonId: string;
  tabPanelId: string;
  qaId: string | undefined;
};

export function TabsItem({
  isSelected,
  children,
  onChange,
  variant,
  tabButtonId,
  tabPanelId,
  qaId,
}: Props) {
  const inputId = `${tabButtonId}-input`;

  return (
    <TabsItemLi data-qa-id="tabs-item">
      <TabsItemInput
        type="radio"
        id={inputId}
        name={inputId}
        checked={isSelected}
        onChange={onChange}
      />

      <TabsItemLabel
        $variant={variant}
        id={tabButtonId}
        htmlFor={inputId}
        data-qa-id={qaId}
        aria-selected={isSelected}
        aria-controls={tabPanelId}
      >
        {children}
      </TabsItemLabel>
    </TabsItemLi>
  );
}
